import React from 'react';
import * as styledComponents from './styles'
import { Container, Row, Col } from 'react-bootstrap';
import MLP from 'media/mlp.png';
import VisibilitySensor from 'react-visibility-sensor';
import { useHistory } from "react-router";

const MLPService =  React.forwardRef((props, ref) => {
  const history = useHistory();
  const changeVisibility = (isVisible)=>{
    if(isVisible){
      history.push('landing?section=mlp&type=scrolled')
    }
  }

  return (
    <VisibilitySensor partialVisibility onChange={changeVisibility}>
    <styledComponents.MLPContainer ref={ref}>
      <Container>
        <Row>
          <Col md>
            <styledComponents.ContainerListDesktop>
              <styledComponents.MLPImage src={MLP}/>
            </styledComponents.ContainerListDesktop>
          </Col>
          <Col md>
            <styledComponents.HeadTitle>SERVICES</styledComponents.HeadTitle>
            <styledComponents.Title>
              WE DEVELOP YOUR MLP
            </styledComponents.Title>
            <styledComponents.ContainerListPhone>
              <styledComponents.MLPImage src={MLP}/>
            </styledComponents.ContainerListPhone>
            <styledComponents.Description>
            MLP or Minimum Lovable Product is an initial offering that your clients love about your product or service from the start. It represents the minimum that is required for customers to adore.             <br /> <br />
            <b>Investment: Quote for service</b>
            </styledComponents.Description>
            <styledComponents.CallToAction onClick={()=>{window.open("https://calendly.com/luisenriquecgongora")}}>QUOTE YOUR MLP</styledComponents.CallToAction>
          </Col>
        </Row>
      </Container>
    </styledComponents.MLPContainer>
    </VisibilitySensor>
  );
});

export default MLPService;
